// extracted by mini-css-extract-plugin
export default {"transactionsCollapse":"styles_transactionsCollapse__3L0w7","expandIconWrap":"styles_expandIconWrap__GdSiv"};